var audio_rtlignore_default = {
  "fontElementMap": "EQfjn",
  "container": "CqcFE",
  "customPlayer": "aj0Vr",
  "slim": "ZTZ6h",
  "playPauseButton": "_53ZPX",
  "coverImage": "_52z7h",
  "trackDetailsContainer": "_8knGH",
  "controlsContainer": "zEVtV",
  "controlsGroup": "LKG1i",
  "sliderContainer": "yTCuH",
  "audioDuration": "cknCN",
  "isLoading": "tnicH",
  "audioIconButton": "u1j4I",
  "audioVolumeWrapper": "Ec1ZG",
  "volumeSliderWrapper": "cRGLo",
  "audioDetails": "qnmvt",
  "authorName": "q0EB8",
  "title": "D8uqs",
  "audioContextMenuWrapper": "ACc9t",
  "dropdownMenuWrapper": "r6aas",
  "dropdownSelectedButton": "AJNjk",
  "dropdownContent": "-gpzS",
  "dropdownContentWithIcon": "_3ZSxH",
  "audioLoader": "JeIPb"
};
export {
  audio_rtlignore_default as default
};
//# sourceMappingURL=audio.rtlignore-scss.js.map
